import { render } from "./DataTableComponent.vue?vue&type=template&id=18f6519c&scoped=true"
import script from "./DataTableComponent.vue?vue&type=script&lang=js"
export * from "./DataTableComponent.vue?vue&type=script&lang=js"

import "./DataTableComponent.vue?vue&type=style&index=0&id=18f6519c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f6519c"]])

export default __exports__